module.exports = __webpack_public_path__ + "static/media/emoji_hey.80cf0c9f.png";